import { supabase } from "@/integrations/supabase/client";

export async function fetchCreditBalance(userId: string): Promise<number | null> {
  const { data, error } = await supabase
    .from("credits")
    .select("balance")
    .eq("user_id", userId)
    .maybeSingle();

  if (error) throw error;
  return data?.balance ?? null;
}

export async function updateCreditBalance(userId: string, newBalance: number): Promise<void> {
  const { error } = await supabase
    .from("credits")
    .update({ balance: newBalance })
    .eq("user_id", userId);

  if (error) throw error;
}

export async function addCreditsToBalance(userId: string, tokensToAdd: number): Promise<number> {
  const { data, error } = await supabase
    .from("credits")
    .select("balance")
    .eq("user_id", userId)
    .single();

  if (error) throw error;

  const newBalance = data.balance + tokensToAdd;

  const { error: updateError } = await supabase
    .from("credits")
    .update({ balance: newBalance })
    .eq("user_id", userId);

  if (updateError) throw updateError;
  return newBalance;
}
